import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=0f9f9c2f&"
import script from "./ButtonBack.vue?vue&type=script&lang=js&"
export * from "./ButtonBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports